export default {"src":"/assets/_next/static/media/img-modal-salary.094b9144.svg","height":905,"width":1195,"blurWidth":0,"blurHeight":0};